// Mirrors backend api/ConfigurationForStore/model.py::_default_invoice_layout_for_type
export const INVOICE_TYPES = ["pos", "retail", "wholesale", "ecom"];

// Visual design variants available for the A4 template. Thermal receipts
// always use their own single layout regardless of this setting.
export const A4_DESIGN_OPTIONS = [
  { key: "classic", label: "Classic" },
  { key: "modern", label: "Modern" },
  { key: "banded", label: "Banded" },
  { key: "compact", label: "Compact" },
];

// Item-table columns the Template Editor's "Adjust Document Column" panel
// can toggle/resize. "#" and "Item" are always shown and not listed here.
export const INVOICE_COLUMN_FIELDS = [
  { key: "qty", label: "Qty" },
  { key: "rate", label: "Rate" },
  { key: "discount", label: "Discount" },
  { key: "tax", label: "Tax" },
  { key: "amount", label: "Amount" },
];

export function getDefaultInvoiceColumns() {
  return {
    qty: { visible: true, width: 0 },
    rate: { visible: true, width: 0 },
    discount: { visible: true, width: 0 },
    tax: { visible: true, width: 0 },
    amount: { visible: true, width: 0 },
  };
}

export function getDefaultInvoiceLayout(invoiceType) {
  return {
    template: invoiceType === "pos" || invoiceType === "retail" ? "thermal" : "a4",
    // Visual design variant for the A4 template (ignored by thermal).
    // One of: "classic", "modern", "banded", "compact".
    design: "classic",
    paper_width: "80mm",
    font_size: "medium",
    show_logo: true,
    show_store_address: true,
    show_customer_block: invoiceType !== "pos",
    show_tax_breakdown: true,
    show_item_discount: true,
    show_notes_footer: true,
    show_barcode: invoiceType === "pos" || invoiceType === "retail",
    show_signature_line: invoiceType === "wholesale" || invoiceType === "ecom",
    header_note: "",
    footer_note: "Thank you for shopping with us",
    // Business identity overrides -- let the owner set what actually prints
    // on the invoice instead of relying on the Store record.
    business_name: "",
    business_address: "",
    business_contact: "",
    // Data-URI images (uploaded via the settings UI) shown at the top/bottom
    // of the printed invoice.
    header_image: "",
    footer_image: "",
    // Branding.
    font_family: "default",
    brand_color: "#0056B3",
    // Per-column visibility/width for the item table on the A4 template.
    columns: getDefaultInvoiceColumns(),
    // Optional extra sections for the A4 template (advanced Template Editor).
    show_bank_details: false,
    bank_name: "",
    bank_account_number: "",
    bank_ifsc: "",
    bank_branch: "",
    show_terms: false,
    terms_text: "",
    show_amount_in_words: false,
  };
}

export function getInvoiceLayoutSettings(storedSettings) {
  const stored = storedSettings || {};
  const result = {};
  INVOICE_TYPES.forEach((type) => {
    const defaults = getDefaultInvoiceLayout(type);
    const value = stored[type] || {};
    result[type] = {
      ...defaults,
      ...value,
      // Deep-merge columns so a layout saved before this field existed (or
      // missing an individual column key) still gets defaults per-column
      // instead of losing the rest when the stored "columns" key is partial.
      columns: { ...defaults.columns, ...(value.columns || {}) },
    };
  });
  return result;
}
